import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const ContactFormTile = () => {
    const [state, handleSubmit] = useForm("mojqkbny");

    if (state.succeeded) {
        return (
            <div className="glass-panel p-8 animate-fade-in-up opacity-0 animation-delay-200">
                <div className="text-center py-8">
                    <div className="text-5xl mb-4">✓</div>
                    <h3 className="text-2xl font-bold text-primary-blue mb-2">Message Sent!</h3>
                    <p className="text-text-light">Thanks for reaching out. We'll get back to you soon.</p>
                </div>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="glass-panel p-8 animate-fade-in-up opacity-0 animation-delay-200">
            <div className="mb-6">
                <label className="block text-sm font-bold mb-2" htmlFor="name">Name</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full p-3 rounded-lg bg-white/50 border border-glass-border focus:outline-none focus:ring-2 focus:ring-primary-blue"
                    required
                    disabled={state.submitting}
                />
                <ValidationError prefix="Name" field="name" errors={state.errors} className="text-red-500 text-sm mt-1" />
            </div>
            <div className="mb-6">
                <label className="block text-sm font-bold mb-2" htmlFor="email">Email</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full p-3 rounded-lg bg-white/50 border border-glass-border focus:outline-none focus:ring-2 focus:ring-primary-blue"
                    required
                    disabled={state.submitting}
                />
                <ValidationError prefix="Email" field="email" errors={state.errors} className="text-red-500 text-sm mt-1" />
            </div>
            <div className="mb-6">
                <label className="block text-sm font-bold mb-2" htmlFor="phone">Phone</label>
                <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="w-full p-3 rounded-lg bg-white/50 border border-glass-border focus:outline-none focus:ring-2 focus:ring-primary-blue"
                    disabled={state.submitting}
                />
                <ValidationError prefix="Phone" field="phone" errors={state.errors} className="text-red-500 text-sm mt-1" />
            </div>
            <div className="mb-6">
                <label className="block text-sm font-bold mb-2" htmlFor="message">Message</label>
                <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className="w-full p-3 rounded-lg bg-white/50 border border-glass-border focus:outline-none focus:ring-2 focus:ring-primary-blue"
                    required
                    disabled={state.submitting}
                ></textarea>
                <ValidationError prefix="Message" field="message" errors={state.errors} className="text-red-500 text-sm mt-1" />
            </div>
            
            <button 
                type="submit" 
                className="glass-button w-full disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={state.submitting}
            >
                {state.submitting ? 'Sending...' : 'Send Message'}
            </button>
        </form>
    );
};

export default ContactFormTile;
